import { useState, useEffect } from 'react';
import './App.css';
import LoginScreen from './screens/LoginScreen';
import PatientLayout from './screens/PatientLayout';
import AdminScreen from './screens/AdminScreen';
import { seedIfEmpty } from './lib/mock';
import { Toaster } from './components/ui/toaster';

function App() {
  const [screen, setScreen] = useState('login');
  const [currentPatient, setCurrentPatient] = useState(null);

  useEffect(() => { seedIfEmpty(); }, []);

  return (
    <div className="App" dir="rtl">
      {screen === 'login' && (
        <LoginScreen
          onPatientLogin={(p) => { setCurrentPatient(p); setScreen('patient'); }}
          onAdminLogin={() => setScreen('admin')}
        />
      )}
      {screen === 'patient' && currentPatient && (
        <PatientLayout patient={currentPatient} onLogout={() => { setCurrentPatient(null); setScreen('login'); }} />
      )}
      {screen === 'admin' && (
        <AdminScreen onLogout={() => setScreen('login')} />
      )}
      <Toaster />
    </div>
  );
}

export default App;
